import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../propTypes';
import './styles.scss';

function ToggleButton({
    id,
    activeText,
    inactiveText,
    onToggle,
    toggleState,
    classNames,
}) {
    return (
        <div className={`checkbox switcher float-right ${classNames}`}>
            <label htmlFor={id}>
                <small>{toggleState ? activeText : inactiveText}</small>
                <input
                    type="checkbox"
                    id={id}
                    onChange={onToggle}
                    value={toggleState}
                    checked={toggleState}
                />
                <span>
                    <small></small>
                </span>
            </label>
        </div>
    );
}

ToggleButton.propTypes = {
    // the id of the toggle button to be used as element id
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // string input to be rendered as the label when toggle is active
    activeText: PropTypes.string,
    // string input to be rendered as the label when toggle is inactive
    inactiveText: PropTypes.string,
    // function to call when the value of the toggle is changed
    onToggle: PropTypes.func,
    // boolean representing the current state of the toggle button
    toggleState: PropTypes.bool,
    classNames: PropTypes.string,
};

ToggleButton.defaultProps = {
    id: 1,
    activeText: 'Active',
    inactiveText: 'Archived',
    onToggle: noop,
    toggleState: true,
    classNames: '',
};

export default ToggleButton;
